import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-align_left_fill",
  "use": "icon-align_left_fill-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-align_left_fill\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n<path d=\"M18,7.5H6V6H18Zm-3,2H6V11h9ZM18,13H6v1.5H18Zm-3,3.5H6V18h9Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol